import React from 'react'
import "./footer.css"
import { assets } from '../../assets/assets'

function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <div className='footer' id='footer'>
      <div className="footer-content">
        <div className="footer-content-left">
          {/* <img src={assets.logo} alt="" /> */}
          <span className='app-title'>Food App.</span>
          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorum, consequatur, odio maxime iste explicabo itaque quia enim sint eaque nemo exercitationem adipisci, corrupti eius hic. Excepturi totam non reprehenderit dolorum!</p>
          <div className="footer-social-icon">
            <img src={assets.facebook_icon} alt="" />
            <img src={assets.twitter_icon} alt="" />
            <img src={assets.linkedin_icon} alt="" />
          </div>
        </div>
        <div className="footer-content-center">
          <h2>COMPPANY</h2>
          <ul>
            <li>Home</li>
            <li>About us</li>
            <li>Delivery</li>
            <li>Privacy policy</li>
          </ul>
        </div>
        <div className="footer-content-right">
          <h2>GET IN Touch</h2>
          <ul>
            <li>+91-000-000-0000</li>
            <li>contact@food.com</li>
          </ul>
        </div>
      </div>
      <hr />
      <p className="footer-copyright">
        Copyright {currentYear} @ foodapp.com - All Right Reserved
      </p>
    </div>
  )
}

export default Footer